import React, { useEffect, useState } from 'react';
import { Box, Typography, Dialog, IconButton } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { makeStyles } from '@mui/styles';
import { getUsers, transferOrganization } from '../../../apis/user';
import { UserModel } from '../../../types/User';
import CustomButton from '../../UI/CustomButton';
import CustomTable from '../../UI/CustomTable';
import { CellType, TProduct } from '../../../types/Common';
import CustomPagination from '../../UI/CustomPagination';
import './assignment.scss';
import SearchComponent from '../Search';

const tableHead = [
  {
    key: 'row',
    label: 'ردیف',
    type: CellType.ROW,
  },
  {
    key: 'name',
    label: 'نام',
    type: CellType.STRING,
  },
  {
    key: 'lastName',
    label: 'نام خانوادگی',
    type: CellType.STRING,
  },
  {
    key: 'mobileNumber',
    label: 'شماره موبایل',
    type: CellType.MOBILE,
  },
  {
    key: 'registrationDate',
    label: 'تاریخ ایجاد ',
    type: CellType.REGISTER_DATE,
  },
];

const useStyles = makeStyles(() => ({
  paper: {
    width: '100%',
    direction: 'rtl',
    borderRadius: '1rem !important',
  },
  root: {
    backgroundColor: '#f4f7f6',
  },
}));

interface TestAssignmentDialogProps {
  openTestAssignmentDialog: boolean;
  closeDialog: () => void;
  onUpdate?: () => void;
  selectedProduct: TProduct;
}

const TestAssignmentDialog: React.FC<TestAssignmentDialogProps> = (props) => {
  const { openTestAssignmentDialog, closeDialog, selectedProduct, onUpdate } = props;
  const styles = useStyles();

  const { productName, productId = 1 } = selectedProduct || {};

  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState<UserModel[]>([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [userSelected, setUserSelected] = useState<number[]>([]);

  const clearAllState = () => {
    setRowsPerPage(10);
    setCurrentPage(1);
    setUserSelected([]);
  };

  const onCloseAndResetDialog = () => {
    clearAllState();
    closeDialog();
  };

  const onSubmit = () => {
    setLoading(true);

    const users = userSelected.map((userId: number) => {
      return {
        user_id: userId,
        products: [
          {
            productId: productId,
            quantity: 1,
          },
        ],
      };
    });

    transferOrganization(users)
      .then(() => {
        clearAllState();
        onUpdate?.();
      })
      .catch((e) => console.log({ e }))
      .finally(() => setLoading(false));
  };

  const getAllUsers = (search?: string) => {
    setLoading(true);
    getUsers(currentPage, rowsPerPage, search)
      .then((res: any) => {
        const newUsers = res.data?.map((i: UserModel) => {
          return {
            ...i,
            id: i.userId,
          };
        });
        setUsers(newUsers || []);
        setTotalPages(res.pagination?.totalPages || 1);
      })
      .catch((e) => console.log({ e }))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (openTestAssignmentDialog) getAllUsers();
  }, [currentPage, rowsPerPage, openTestAssignmentDialog]);

  return (
    <Dialog
      onClose={onCloseAndResetDialog}
      open={openTestAssignmentDialog}
      maxWidth='xl'
      classes={{ paper: styles.paper }}
    >
      <Box className='mainDialog'>
        <Box className='header'>
          <Typography color='text.main' fontWeight='bold'>
            {`تخصیص ${productName} به کاربران`}
          </Typography>
          <IconButton onClick={onCloseAndResetDialog}>
            <CloseRoundedIcon color='action' />
          </IconButton>
        </Box>

        <Box className='mainTestContent'>
          <Box className='spaceBetween'>
            <Typography mb={2}>
              برای تخصیص تست، از جدول زیر ابتدا کاربران رو انتخاب سپس دکمه تایید رو کلیک کنید
            </Typography>

            <SearchComponent getAllUsers={getAllUsers} />
          </Box>

          <CustomTable
            rows={users}
            tableHead={tableHead}
            selected={userSelected}
            loading={loading}
            rowsIndex={rowsPerPage * (currentPage - 1)}
            size='small'
            setSelected={setUserSelected}
          />

          <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onChangeCurrentPage={(page: number) => setCurrentPage(page)}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={(rowsPerPage: number) => {
              if (currentPage !== 0) setCurrentPage(1);
              setRowsPerPage(rowsPerPage);
            }}
          />

          <Box mt={1} display='flex' justifyContent='end'>
            <CustomButton onClick={onSubmit} loading={loading} disabled={loading}>
              تایید
            </CustomButton>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default TestAssignmentDialog;
